(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4476],{

/***/ 48154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ErrorLabel_ErrorLabel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/ErrorLabel/ErrorLabel.js






const ErrorLabelText = (param)=>/*#__PURE__*/ {
    let { className ="" , children , ...props } = param;
    return (0,jsx_runtime.jsx)("span", {
        className: (0,classes/* classes */.S)("error-label__wrap", className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "error-label__wrap-text",
            children: children
        })
    });
};
ErrorLabelText.propTypes = {
    className: prop_types.string,
    children: prop_types.node.isRequired
};
const ErrorLabel = (param)=>/*#__PURE__*/ {
    let { className ="" , children , ...props } = param;
    return (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        Tag: "span",
        className: (0,classes/* classes */.S)("field--error", className),
        ...props,
        children: children
    });
};
ErrorLabel.propTypes = {
    className: prop_types.string,
    children: prop_types.node.isRequired
};
ErrorLabel.Text = ErrorLabelText;
/* harmony default export */ var ErrorLabel_ErrorLabel = ((0,pureFC/* default */.Z)(ErrorLabel));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/ErrorLabel/index.js



/***/ }),

/***/ 22950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Form_Form; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Form/Form.js





const Form = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)("form", {
        className: (0,classes/* classes */.S)("form form--stacked", className),
        ...props
    });
};
Form.propTypes = {
    className: prop_types.string
};
/* harmony default export */ var Form_Form = ((0,pureFC/* default */.Z)(Form));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Form/index.js



/***/ }),

/***/ 85725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FormField_FormField; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sizing.js
var props_sizing = __webpack_require__(88270);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FormGroup/FormGroup.js








const FormGroup = (param)=>/*#__PURE__*/ {
    let { isCheckBox =false , isRadio =false , required , error =false , className , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sizing ={
        ...props_sizing/* sizingProps */.H6
    } , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("field", isCheckBox && "field-checkbox", isRadio && "field-radio", required && "field--required", error && "field--error", ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_spacing/* spacingClassName */.RB)(spacing), ...(0,props_sizing/* sizingClassName */.rs)(sizing), className),
        ...props
    });
};
FormGroup.propTypes = {
    isCheckBox: prop_types.bool,
    isRadio: prop_types.bool,
    required: prop_types.bool,
    error: prop_types.node,
    className: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    sizing: props_sizing/* sizingPropTypes */.bm
};
/* harmony default export */ var FormGroup_FormGroup = ((0,pureFC/* default */.Z)(FormGroup));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FormGroup/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Label/index.js + 1 modules
var Label = __webpack_require__(76223);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FieldHint/FieldHint.js





const FieldHint = (param)=>/*#__PURE__*/ {
    let { isActive =false , className , ...props } = param;
    return (0,jsx_runtime.jsx)("span", {
        className: (0,classes/* classes */.S)("field__hint", isActive && "field__hint--active", className),
        ...props
    });
};
FieldHint.propTypes = {
    isActive: prop_types.bool,
    className: (prop_types_default()).string
};
/* harmony default export */ var FieldHint_FieldHint = ((0,pureFC/* default */.Z)(FieldHint));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FieldHint/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/ErrorLabel/index.js + 1 modules
var ErrorLabel = __webpack_require__(48154);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Input/index.js + 2 modules
var Input = __webpack_require__(6470);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FieldLink/FieldLink.js





const FieldLink = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("field__link", className),
        ...props
    });
};
FieldLink.propTypes = {
    className: (prop_types_default()).string
};
/* harmony default export */ var FieldLink_FieldLink = ((0,pureFC/* default */.Z)(FieldLink));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FieldLink/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/predicates.js
var predicates = __webpack_require__(53863);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FormField/FormField.js














const FormField = (param)=>/*#__PURE__*/ {
    let { label , required , hint , error =null , link , Control =Input/* default */.Z , children , fieldClassName , inverted =false , onLabelClick , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sizing ={
        ...props_sizing/* sizingProps */.H6
    } , ...props } = param;
    return (0,jsx_runtime.jsxs)(FormGroup_FormGroup, {
        required: required,
        className: fieldClassName,
        error: error,
        spacing: spacing,
        utility: utility,
        sizing: sizing,
        children: [
            (0,predicates/* isString */.HD)(label) ? // eslint-disable-next-line react/destructuring-assignment
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                htmlFor: props.id,
                inverted: inverted,
                onClick: onLabelClick,
                children: label
            }) : label,
            Control && /*#__PURE__*/ (0,jsx_runtime.jsx)(Control, {
                ...props,
                error: error,
                children: children
            }),
            !Control && children,
            (0,predicates/* isString */.HD)(hint) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldHint_FieldHint, {
                children: hint
            }) : hint,
            (0,predicates/* isString */.HD)(error) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorLabel/* default */.Z, {
                children: error
            }) : error,
            link && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldLink_FieldLink, {
                children: link
            })
        ]
    });
};
FormField.propTypes = {
    id: prop_types.string,
    label: prop_types.node,
    required: prop_types.bool,
    hint: prop_types.node,
    error: prop_types.node,
    link: prop_types.node,
    Control: prop_types.elementType,
    children: prop_types.node,
    fieldClassName: prop_types.string,
    inverted: prop_types.bool,
    onLabelClick: prop_types.func,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    sizing: props_sizing/* sizingPropTypes */.bm
};
/* harmony default export */ var FormField_FormField = ((0,pureFC/* default */.Z)(FormField));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FormField/index.js



/***/ }),

/***/ 6470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Input_Input; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/utils/invariant.js
/**
 * @param {boolean} condition
 * @param {string} message
 */ const invariant = (condition, message)=>{
    if (false) {}
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/forward-ref/index.js
var forward_ref = __webpack_require__(52418);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Input/Input.js










const Input = (param)=>{
    let { type ="text" , hideInputNumberArrows =true , maxLength =250 , error , className , forwardRef , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    invariant(/^(button|reset|submit)$/.test(type), "Use <Button /> component instead of Input");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
        type: type,
        maxLength: maxLength,
        ref: forwardRef,
        className: (0,classes/* classes */.S)("field__input", "field__".concat(type), type === "number" && hideInputNumberArrows && "hidden-arrows", error && "field--error", ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props
    });
};
Input.propTypes = {
    type: (0,prop_types.oneOf)([
        "email",
        "file",
        "hidden",
        "number",
        "password",
        "range",
        "search",
        "tel",
        "text",
        "url"
    ]),
    className: prop_types.string,
    maxLength: prop_types.number,
    error: (0,prop_types.oneOfType)([
        prop_types.bool,
        prop_types.string,
        prop_types.node
    ]),
    hideInputNumberArrows: prop_types.bool,
    forwardRef: forward_ref/* default */.Z,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Input_Input = ((0,pureFC/* default */.Z)(Input));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Input/index.js



/***/ }),

/***/ 76223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Label_Label; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Label/Label.js
/* eslint-disable jsx-a11y/label-has-associated-control */ 




const Label = (param)=>/*#__PURE__*/ {
    let { className ="" , uppercase =true , width , inverted =false , ...props } = param;
    return (0,jsx_runtime.jsx)("label", {
        className: (0,classes/* classes */.S)("field__label", !uppercase && "field__label--transform-none", inverted && "field__label--inverted", width && "w-".concat(width), className),
        ...props
    });
};
Label.propTypes = {
    uppercase: prop_types.bool,
    width: prop_types.number,
    className: prop_types.string,
    inverted: prop_types.bool
};
/* harmony default export */ var Label_Label = ((0,pureFC/* default */.Z)(Label));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Label/index.js



/***/ }),

/***/ 89271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Select_Select; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/forward-ref/index.js
var forward_ref = __webpack_require__(52418);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Select/Select.js





const Select = (param)=>/*#__PURE__*/ {
    let { className , error , forwardRef , ...props } = param;
    return (0,jsx_runtime.jsx)("select", {
        ref: forwardRef,
        className: (0,classes/* classes */.S)("field__select", error && "field--error", className),
        ...props
    });
};
Select.propTypes = {
    className: prop_types.string,
    error: (0,prop_types.oneOfType)([
        prop_types.bool,
        prop_types.string,
        prop_types.node
    ]),
    forwardRef: forward_ref/* default */.Z
};
const MSelect = /*#__PURE__*/ react.memo(Select);
MSelect.Placeholder = function SelectPlaceholder(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
        value: "",
        ...props
    });
};
const getValue = (item)=>{
    return item === null || item === void 0 ? void 0 : item.value;
};
const getTitle = (item)=>{
    return item === null || item === void 0 ? void 0 : item.title;
};
// eslint-disable-next-line react/display-name
const renderItem = function() {
    let prepareValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getValue, prepareText = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getTitle;
    return (item)=>{
        const value = prepareValue(item);
        const text = prepareText(item);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
            value: value,
            children: text
        }, value);
    };
};
MSelect.renderOptions = (items, prepareValue, prepareText)=>items.map(renderItem(prepareValue, prepareText));
/* harmony default export */ var Select_Select = (MSelect);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Select/index.js



/***/ }),

/***/ 94746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74229);




const SimpleTemplateDescription = (param)=>{
    let { className ="" , center =true , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        size: "l",
        center: center,
        className: className,
        ...props,
        children: children
    });
};
SimpleTemplateDescription.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleTemplateDescription);


/***/ }),

/***/ 70504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42866);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2349);







const SimpleTemplateTitle = (param)=>{
    let { sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , className ="" , size ="xl" , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: "h1",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)(...(0,_props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* .deepMergeProps */ .p)({
            fontSize: size,
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* .deepMergeProps */ .p)({
            mb: 6
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(spacing))), className),
        ...props,
        children: children
    });
};
SimpleTemplateTitle.propTypes = {
    ..._Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleTemplateTitle);


/***/ }),

/***/ 35449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SimpleTemplate_SimpleTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/Panel.js





const Panel = (param)=>{
    let { className ="" , shadow , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
        className: (0,classes/* classes */.S)("panel", shadow && "panel--shadow", className),
        ...props
    });
};
Panel.propTypes = {
    shadow: prop_types.bool,
    ...Block/* default.propTypes */.Z.propTypes
};
/* harmony default export */ var Panel_Panel = (Panel);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/SimpleTemplate.js










const SimpleTemplate = (param)=>{
    let { cellWidth =8 , mdCellWidth =10 , paddingTop ="pt-9 pt-9--md" , paddingBottom ="pb-18 pb-18--md" , panel =true , panelPaddingY =16 , panelUtility ={
        ...props_utility/* utilityProps */.Gm
    } , children , bgColor =color/* bgColorBlack2 */.vk , className ="" , shadow =true , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)(paddingTop, paddingBottom, !(utility && utility.bgColor) && bgColor, ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    md: mdCellWidth,
                    lg: cellWidth,
                    children: panel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Panel_Panel, {
                        shadow: shadow,
                        utility: panelUtility,
                        spacing: {
                            py: panelPaddingY
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                            mx: true,
                            px: true,
                            utility: {
                                justify: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                md: 10,
                                children: children
                            })
                        })
                    }) : children
                })
            })
        })
    });
};
SimpleTemplate.propTypes = {
    shadow: prop_types.bool,
    cellWidth: prop_types.number,
    mdCellWidth: prop_types.number,
    paddingTop: prop_types.string,
    paddingBottom: prop_types.string,
    panel: prop_types.bool,
    panelPaddingY: prop_types.number,
    panelUtility: props_utility/* utilityPropTypes */.pQ,
    children: prop_types.node.isRequired,
    bgColor: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    className: prop_types.string
};
/* harmony default export */ var SimpleTemplate_SimpleTemplate = (SimpleTemplate);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js



/***/ }),

/***/ 12985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const ContentContainer = (param)=>{
    let { mx =false , px =false , my =false , py =false , sm ="" , md ="" , lg ="" , center =false , containerClassName ="" , className ="" , isFluid =false , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
        className: containerClassName,
        isFluid: isFluid,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
            mx: mx,
            px: px,
            my: my,
            py: py,
            className: className,
            center: center,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                sm: sm,
                md: md,
                lg: lg,
                children: children
            })
        })
    });
};
ContentContainer.propTypes = {
    mx: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    px: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    my: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    py: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    containerClassName: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    isFluid: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentContainer);


/***/ }),

/***/ 81465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ diffDays; }
/* harmony export */ });
const MS_IN_DAY = 1000 * 60 * 60 * 24;
/**
 * Returns difference between two dates in days
 *
 * @type {(date1: Date, date2: Date, toInt?: (x: number) => number)}
 */ const diffDays = function(date1, date2) {
    let toInt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Math.ceil;
    const diffTime = date2 - date1;
    return toInt(diffTime / MS_IN_DAY);
};


/***/ }),

/***/ 77915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10455);

/**
 * Type `SyncType<T>` - Type extracts type packed into the Promise
 *
 * @template T
 * @typedef {T extends Promise<infer Packed> ? Packed : T} SyncType
 */ const packToBuf = (buffer, field)=>(result)=>{
        // eslint-disable-next-line no-param-reassign
        buffer[field] = result;
        return buffer;
    };
const resolveToBuffer = (param)=>{
    let [field, resolver] = param;
    return (args, buffer)=>{
        try {
            const result = resolver(...args);
            const pack = packToBuf(buffer, field);
            return (0,___WEBPACK_IMPORTED_MODULE_0__/* .isPromise */ .tI)(result) ? result.then(pack) : pack(result);
        } catch (err) {
            return Promise.reject(err);
        }
    };
};
const resolversWrapper = (resolvers)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        const buffer = {};
        const promises = resolvers.map((0,___WEBPACK_IMPORTED_MODULE_0__/* .call */ .RE)(args, buffer));
        return Promise.all(promises).then(()=>buffer);
    };
const prepareResolvers = (param)=>{
    let [field, resolver] = param;
    return resolveToBuffer([
        field,
        (0,___WEBPACK_IMPORTED_MODULE_0__/* .ensureFunc */ .KX)(resolver, ()=>resolver)
    ]);
};
/**
 * Creates new functions that returns Promise resolving to an object with
 * values returned by functions specified for correspondent fields of argument
 * object
 *
 * @example
 * const fn = propsResolver({
 * 	x: () => 1,
 *  y: () => 2,
 * });
 * fn().then(console.log); // prints: { x: 1, y: 2 }
 *
 * @type {
 	<
		A extends any[],
		M extends { [p in string]: (...args: any[]) => any }
	>(resolversMap: M) => (...args: A) => Promise<{ [k in keyof M]: SyncType<ReturnType<M[k]>> }>
 }
 */ const propsResolver = (resolversMap)=>resolversWrapper(Object.entries(resolversMap).map(prepareResolvers));
/* harmony default export */ __webpack_exports__["Z"] = (propsResolver);


/***/ }),

/***/ 73193:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* eslint-disable no-nested-ternary, prettier/prettier */ const str2Int = (str, def)=>{
    const value = parseInt(str, 10);
    return Number.isNaN(value) ? def : value;
};
/**
 * Parses Number
 */ const parseNumber = (value, def)=>typeof value === "string" ? str2Int(value, def) : typeof value === "number" ? value : def;
/* harmony default export */ __webpack_exports__["Z"] = (parseNumber);


/***/ }),

/***/ 66651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

class ApplicationError extends Error {
    toSerializable() {
        const { name , message , code , stack , originalError , tags  } = this;
        return {
            name,
            message,
            code,
            stack: typeof stack === "string" ? stack.split("\n") : stack,
            originalError: originalError ? {
                name: originalError.name,
                code: originalError.code,
                message: originalError.message
            } : null,
            tags
        };
    }
    toJSON() {
        return this.toSerializable();
    }
    constructor(originalError, code = 500, message = ApplicationError.defaultMessage[code], tags = null){
        super(message);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "name", "ApplicationError");
        this.code = code;
        this.originalError = originalError;
        this.stack = (originalError === null || originalError === void 0 ? void 0 : originalError.stack) || new Error().stack;
        this.tags = tags;
    }
}
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "defaultMessage", {
    400: "Bad Request",
    401: "Not Authorized",
    403: "Not Permitted",
    404: "Not Found",
    500: "Internal Error"
});
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "of", (error)=>error instanceof ApplicationError ? error : new ApplicationError(error, error.code || 500, error.message));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "BadRequest", ()=>new ApplicationError(null, 400));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "NotAuthorized", ()=>new ApplicationError(null, 401));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "NotFound", ()=>new ApplicationError(null, 404));
/* harmony default export */ __webpack_exports__["Z"] = (ApplicationError);


/***/ }),

/***/ 4354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ withForceError; }
/* harmony export */ });
/* unused harmony export throwError */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10455);
/* harmony import */ var _url_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89333);
/* harmony import */ var _displayName__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75511);
/* harmony import */ var _ApplicationError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66651);







const getCurrentPath = (param)=>{
    let { asPath  } = param;
    return asPath;
};
const getQueryParam = function() {
    let paramName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "throw";
    return (pathname)=>(0,_url_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(pathname)[paramName];
};
const parseErrorParams = (wsParamValue)=>/(-?\d+)-([^-].*)/.exec(wsParamValue) || [];
const normalizeParams = (param)=>{
    let [, code, message] = param;
    return [
        code && parseInt(code, 10),
        message
    ];
};
const getErrorParamsFromPath = (paramName)=>(0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .compose */ .qC)(normalizeParams, parseErrorParams, getQueryParam(paramName), getCurrentPath);
const throwError = (getInitialProps, paramName)=>(context)=>{
        const [code, message] = getErrorParamsFromPath(paramName)(context);
        if (code == null) {
            return (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .isFunc */ .Wl)(getInitialProps) ? getInitialProps(context) : {
                __throwError: true
            };
        }
        if (code < 0) throw new _ApplicationError__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(new Error("Server Side: ".concat(message)), -code, "Server Side: ".concat(message));
        return {
            errorToThrow: {
                code,
                message
            }
        };
    };
/** @type {(paramName: string) => <P extends {}>(Component: React.Component<P>) => React.FC<P>} */ const withForceErrorHOC = (paramName)=>(Component)=>{
        const ComponentWithThrowError = (param)=>{
            let { errorToThrow , ...props } = param;
            if (errorToThrow && "object" !== "undefined") throw new _ApplicationError__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(new Error("Client Side: ".concat(errorToThrow.message)), errorToThrow.code, "Client Side: ".concat(errorToThrow.message));
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...props
            });
        };
        ComponentWithThrowError.propTypes = {
            ...Component.propTypes,
            errorToThrow: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.shape)({
                code: prop_types__WEBPACK_IMPORTED_MODULE_5__.number,
                message: prop_types__WEBPACK_IMPORTED_MODULE_5__.string
            })
        };
        ComponentWithThrowError.displayName = (0,_displayName__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("withForceError", Component);
        ComponentWithThrowError.getInitialProps = throwError(Component.getInitialProps, paramName);
        return ComponentWithThrowError;
    };
const withForceError = withForceErrorHOC;


/***/ }),

/***/ 93890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports MetaTwitter, MetaOGP */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84154);





const Robots = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "robots",
            content: content
        })
    });
};
Robots.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Author = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "author",
            content: content
        })
    });
};
Author.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Canonical = (param)=>/*#__PURE__*/ {
    let { href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: href
        })
    });
};
Canonical.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
const CanonicalAlternate = (param)=>/*#__PURE__*/ {
    let { type ="text/html" , hrefLang , href , title =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "alternate",
            type: type,
            hrefLang: hrefLang,
            href: href,
            title: title
        })
    });
};
CanonicalAlternate.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const MetaTwitter = (param)=>{
    let { card ="" , title ="" , description ="" , site ="" , image ="" , creator ="" , isImageBaseUrl =false  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            card && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: card
            }),
            site && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: site
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: "".concat(baseUrl).concat(image)
            }),
            creator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: creator
            })
        ]
    });
};
MetaTwitter.propTypes = {
    card: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    site: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    creator: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
const MetaOGP = (param)=>{
    let { isImageBaseUrl =false , title ="" , description ="" , locale ="" , type ="" , url ="" , image ="" , imageSecureUrl ="" , siteName ="" , articlePublisher =""  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            locale && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: locale
            }),
            type && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "".concat(baseUrl).concat(image)
            }),
            imageSecureUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: "".concat(baseUrl).concat(imageSecureUrl)
            }),
            siteName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            articlePublisher && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:publisher",
                content: articlePublisher
            })
        ]
    });
};
MetaOGP.propTypes = {
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    locale: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    url: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    imageSecureUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    siteName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    articlePublisher: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const PageMeta = (param)=>{
    let { title ="" , description ="" , children =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            children
        ]
    });
};
const CustomHead = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
CustomHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
PageMeta.Robots = Robots;
PageMeta.Custom = CustomHead;
PageMeta.Canonical = Canonical;
PageMeta.CanonicalAlternate = CanonicalAlternate;
PageMeta.Author = Author;
PageMeta.Twitter = MetaTwitter;
PageMeta.OGP = MetaOGP;
PageMeta.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
/* harmony default export */ __webpack_exports__["ZP"] = (PageMeta);


/***/ }),

/***/ 23740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useIfMounted; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useUniEffect =  false ? 0 : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
function useUnmounted() {
    const unmountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    useUniEffect(()=>{
        unmountedRef.current = false;
        return ()=>{
            unmountedRef.current = true;
        };
    }, []);
    return unmountedRef;
}
function useIfMounted(fn, isUnmountedRef) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (isUnmountedRef.current) return undefined;
        return fn(...args);
    }, [
        fn,
        isUnmountedRef
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useUnmounted);


/***/ }),

/***/ 66728:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const defaultSetting = {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
};
const currencyFormatter = (options)=>new Intl.NumberFormat("en-US", {
        ...defaultSetting,
        ...options
    });
const currency = function(amount) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const parsed = typeof amount === "string" ? parseFloat(amount) : amount;
    return typeof parsed === "number" && !Number.isNaN(parsed) ? currencyFormatter(options).format(parsed) : amount;
};
/* harmony default export */ __webpack_exports__["Z"] = (currency);


/***/ }),

/***/ 89333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11987);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(url__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97334);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(querystring__WEBPACK_IMPORTED_MODULE_1__);


const query = (path)=>querystring__WEBPACK_IMPORTED_MODULE_1___default().parse((0,url__WEBPACK_IMPORTED_MODULE_0__.parse)(path).query);
/* harmony default export */ __webpack_exports__["Z"] = (query);


/***/ }),

/***/ 59074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "av": function() { return /* binding */ CATCH; }
/* harmony export */ });
/* unused harmony exports FINALLY, THEN */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10455);
/* harmony import */ var _hooks_useUnmounted__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23740);



const FINALLY = "finally";
const THEN = "then";
const CATCH = "catch";
function useTracking(action) {
    let endOn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : FINALLY;
    const unmounted = (0,_hooks_useUnmounted__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const end = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((resOrErr)=>{
        if (!unmounted.current) {
            setLoading(false); // setting loading off
        }
        if (endOn === CATCH) throw resOrErr;
        return resOrErr;
    }, []);
    const trackedAction = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        const result = action(...args);
        if (!(0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_2__/* .isPromise */ .tI)(result)) return result;
        setLoading(true);
        return result[endOn](end);
    }, [
        action
    ]);
    return [
        trackedAction,
        loading
    ];
}
/* harmony default export */ __webpack_exports__["ZP"] = (useTracking);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ })

}]);